import styled from 'styled-components';
import { getColor } from '../../../../../../utils/helper';

const AccordianBody = styled.div`
  background: #f0f0f0;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-top: none;
  border-radius: 0 0 8px 8px;
  padding: 16px;
  border: ${({ isShow }) => (isShow ? '1px solid rgba(0, 0, 0, 0.3)' : 'none')};

  overflow: hidden;
  max-height: ${({ isShow }) => (isShow ? '2000px' : '0')};
  padding: ${({ isShow }) => (isShow ? '16px' : '0 16px')};
  transition: max-height 0.3s ease-in-out, padding 0.3s ease-in-out,
    border 0.3s ease-in-out;

  div {
    margin-bottom: 0px;
  }
`;

const SelectImageButton = styled.div`
  display: inline-flex;
  padding: 9.5px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: ${({ theme, disabled, bgprimary }) =>
    disabled
      ? getColor('gray40', theme)
      : bgprimary === 'true'
      ? theme.primary
      : theme.secondary};
  box-shadow: 0px 8px 16px 0px
      ${({ disabled }) => (disabled ? 'none' : 'rgba(136, 61, 174, 0.24)')},
    ${({ disabled }) => (disabled ? 'none' : 'rgba(136, 61, 174, 0.24)')};
  color: ${({ theme }) => theme.white};
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  margin-bottom: 10px;
  cursor: pointer;
`;

const ImageContainer = styled.div`
  display: flex;
  width: 420px;
  height: 200px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  img {
    border-radius: 8px;
    object-fit: cover;
    max-height: 200px;
    max-width: 420px;
  }
`;

const StyleContainer = styled.div`
  max-height: 300px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 20px;
  margin-top: 10px;
  border: 2px solid
    ${({ theme, selected }) => (selected ? theme.primary : 'none')};
  padding: 2px;
  position: relative;
  cursor: pointer;
  img {
    max-height: 290px;
    height: 100%;
    object-fit: contain;
  }
`;

export const CarouselTheming = {
  AccordianBody,
  SelectImageButton,
  ImageContainer,
  StyleContainer,
};
